import { USER_STATUS } from "./buildUser";
import { type GetUserStatusesType } from "./contract";
import { MEMBERSHIP_STATUS } from "./membershipStatus";

const getUserStatuses: GetUserStatusesType = ({
  fetching,
  membership,
  status,
}) => ({
  isFetching: fetching,
  isLoading: status === USER_STATUS.loading,
  isLogged: status === USER_STATUS.logged,
  isPrime:
    status !== USER_STATUS.loading &&
    membership?.status === MEMBERSHIP_STATUS.activated,
  isRemembered: status === USER_STATUS.remembered,
});

export default getUserStatuses;
